package app.nestbridge.feature.invitations.presentation

import app.nestbridge.feature.invitations.screen.InvitationConfirmationScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(InvitationConfirmationPresenter::class)
public class InvitationConfirmationPresenterFactory(
  private val factory:
      (navigator: Navigator, screen: InvitationConfirmationScreen) -> InvitationConfirmationPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is InvitationConfirmationScreen -> factory(navigator, screen)
    else -> null
  }
}
